"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _profile = require("@/api/profile");

var _admin = require("@/api/admin");

//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      hasNotice: false,
      timer: "",
      counter: 1
    };
  },
  mounted: function mounted() {
    this.timer = setInterval(this.checkNotice, 30 * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  created: function created() {
    this.checkNotice();
  },
  methods: {
    click: function click() {
      this.$router.push({
        path: "/profile/notice"
      });
    },
    checkNotice: function checkNotice() {
      var _this = this;

      (0, _admin.online)(); // 30秒一次 报告在线状态

      if (this.hasNotice && this.counter % 3 != 0) {
        this.counter = this.counter + 1;
        return;
      }

      this.counter = this.counter + 1;
      (0, _profile.nNotice)().then(function (response) {
        _this.hasNotice = !_this.isEmptyObjVue(response.data.data);
        if (_this.hasNotice == false) return;
        var result = response.data.data;

        if (!("Notification" in window) || Notification.permission === "denied") {
          //不支持 走notify控件
          _this.$notify({
            title: result.noticeTitle,
            message: result.content,
            position: 'bottom-right',
            onClick: function onClick() {
              _this.skip(result.notifyType, result.id);
            },
            offset: 10,
            duration: 3 * 60 * 1000
          });
        } else if (Notification.permission === "granted") {
          //客户端允许通知
          console.info('客户端允许通知');

          _this.showNotification(result.noticeTitle, result.content, result.notifyType, result.id);
        } else if (Notification.permission !== "denied") {
          console.info('客户端禁止通知');
          Notification.requestPermission(function (status) {
            if (status != "granted") return;
            this.showNotification(result.noticeTitle, result.content, result.notifyType, result.id);
          });
        }
      });
    },
    showNotification: function showNotification(title, content, type, id) {
      var that = this;
      var notification = new Notification(title, {
        lang: 'zh',
        duration: 10000,
        icon: '',
        body: content
      });

      notification.onclick = function () {
        console.info(id);
        that.skip(type, id);
        notification.close();
      };
    },
    skip: function skip(notifyType, id) {
      var path = "/callcenter/callcenter";
      if ('newOB' == notifyType) path = "/callcenter/callcenter";

      if (this.isEmptyObjVue(path)) {
        path = "/profile/notice";
      } //设置为已读


      var ids = [];
      ids.push(id);
      (0, _profile.brmNotice)({
        ids: ids
      }).then();
      this.$router.push({
        path: path
        /*query: {
          id: row.serviceDataId,
        },*/

      });
    }
  }
};
exports.default = _default;